import { addDataLayerEntry } from '@printdeal/data-layer-manager';

const EventTypes = {
  EEC: 'gaEvent',
};

const ActionTypes = {
  CLICK: 'click',
};

interface DesignTemplateDataLayerOnClickDataProps {
  category: string;
  label: string;
}

export const dispatchDataLayerEventOnClick = (data: DesignTemplateDataLayerOnClickDataProps) => {
  const { category, label } = data;
  addDataLayerEntry(EventTypes.EEC, {
    gaEvent: {
      eventCategory: category,
      eventLabel: label,
      eventAction: ActionTypes.CLICK,
      eventNonInteraction: true,
    },
  });
};
